module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chap_title",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("c. 11,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('h2', {
    staticClass: "section1"
  }, [_vm._v("Wheat: The Staff of Life "), _c('span', {
    staticClass: "gray1"
  }, [_vm._v("• "), _c('em', [_vm._v("Michael C. Gerald with Gloria E. Gerald")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Wheat was one of the first crops to be cultivated and stored on a large-scale basis, transforming hunter-gathers into farmers, and it was instrumental in the establishment of city-states leading to the Babylonian and Assyrian empires. Wheat originally grew wild in the Fertile Crescent of the Middle East and in southwestern Asia. The archeological evidence traces the origins of wheat to wild grasses, such as wild emmer ("), _c('em', [_vm._v("Triticum dicoccum")]), _vm._v("), which was gathered for food in Iraq in 11,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(", and einkorn ("), _c('em', [_vm._v("T. monococcum)")]), _vm._v(", grown in Syria 7800–7500 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(". Wheat was farmed in the Nile Valley of Egypt before 5000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(", where Joseph of the Hebrew Bible was overseeing grain stores in 1800 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A natural hybrid, wheat was derived from cross-pollination of grains. Over thousands of years, farmers and breeders have cross-hybridized grains to maximize the qualities they deemed most desirable. During the nineteenth century, single genetic strains were selectively produced that possessed the traits they were seeking. With a growing understanding of Mendelian inheritance, two lines were crossbred, and the progeny inbred for ten or more generations to obtain and maximize specific characteristics. The twentieth century saw the development and planting of hybrids selected on such desirable characteristics as large kernels, short straw, hardiness to cold, and resistance to insects and to fungal, bacterial, and viral diseases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In recent decades, bacteria have been used to transfer genetic information to produce transgenic wheat. Such genetically modified crops (GMC) have been engineered to produce greater yields, require less nitrogen to grow, and offer greater nutritional value. In 2012, the whole genome of bread wheat was completed and found to have 96,000 genes. This marks an important step in continuing the production of genetically modified wheat, in which more specific desirable characteristics can be inserted in specific loci on the wheat chromosomes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As rice is a dietary staple in Asia, so is wheat in Europe, North America, and western Asia. Wheat is the most widely consumed cereal grain in the world, and world trade in wheat is greater than all other crops combined.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c03_r1#c03"
    }
  }, [_vm._v("Agriculture (c. 10,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c04_r1#c04"
    }
  }, [_vm._v("Domestication of Animals (c. 10,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c05_r1#c05"
    }
  }, [_vm._v("Rice Cultivation (c. 7000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c211_r1#c211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Revolution (1961)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("This Chinese farmer is carrying bushels of dry wheat, as did his ancestors for thousands of years.")])]), _vm._v(" "), _c('div', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "page15_1",
      "src": "Images/15-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c42430","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454933007_epub_c02_r1.vue
// module id = 75
// module chunks = 0